// extracted by mini-css-extract-plugin
export var separatorTilde = "separatorTilde-module--separatorTilde--2EuOk";